/* eslint-disable react/prop-types */
import React from "react";
const { Component } = React;
import $ from "jquery";
import moment from "moment";
import { getRandomString } from "./Common";
import DeliverySelectorDatetime from "./SlotSelector/SlotSelectorDatetime";

export default class DeliveryHeader extends Component {
    state = {
        initialized: false,
    };

    apiUrl = "/time-slots";

    constructor() {
        super();
        this.selectedDateTime = $("#pottsalat-checkout-delivery").data(
            "delivery-datetime"
        );
        this.cookie = window.cookie.get();
    }

    watchdog() {
        if ($('#goto-delivery:not(".watchdog")').length) {
            this.updateData();
            $("#goto-delivery")
                .addClass("watchdog")
                .click((e) => {
                    e.preventDefault();
                    $(".step-delivery").click();
                });
        }
        window.setTimeout(() => this.watchdog(), 50);
    }

    componentDidMount() {
        this.watchdog();
        $.get(this.props.config.url + this.apiUrl, this.generateParams()).then(
            (data) => {
                this.setState({
                    initialized: true,
                    slots: data.delivery_datetimes,
                    currentDate: 0,
                    holiday: data.holiday,
                    notTodayWarning:
                        moment(data.delivery_datetimes[0].moment).weekday() !==
                        moment().weekday(),
                });
            }
        );
        $("body").on("wc_gzdp_step_refreshed", () => {
            this.updateData();
        });
        $(document.body).on("wc_fragments_refreshed", () => {
            this.updateData();
        });
    }

    updateData() {
        $.get(this.props.config.url + this.apiUrl, this.generateParams()).then(
            (data) => {
                this.setState({
                    slots: data.delivery_datetimes,
                });
            }
        );
    }

    generateParams() {
        return {
            area: this.cookie.area.id,
            r: getRandomString(),
        };
    }
    /*
    changeDate(evt) {
        let date_id = 0;
        for (let i = 0; i < this.state.slots.length; i++) {
            if (this.state.slots[i].date === evt.target.value) {
                date_id = i;
                break;
            }
        }
        this.setState({
            currentDate: date_id
        });
    }
    */

    render() {
        if (!this.state.initialized) return <div>...</div>;
        return (
            <div id="delivery-checkout-fields">
                {this.state.holiday && (
                    <div id="holiday-warning">
                        Achtung! Wir haben heute Urlaub. Bitte achte auf den
                        ausgewählten Bestell-Tag.
                    </div>
                )}
                <DeliverySelectorDatetime slots={this.state.slots} />
                {this.state.notTodayWarning && (
                    <p>Achtung! Unser nächster Lieferslot ist nicht heute.</p>
                )}
            </div>
        );
    }

    /*

    renderDateOptions() {
        let result = [];
        for (let i = 0; i < this.state.slots.length; i++) {
            let opts = {};
            result.push(
                <option value={this.state.slots[i].date} {...opts} key={`date${i}`}>
                    {this.renderDateDescr(i, this.state.slots[i].weekday)}, am {this.formatDate(this.state.slots[i].date)}
                </option>
            );
        }
        return result;
    }

    renderDateTimeOptions() {
        let result_lunch = [];
        let result_supper = [];
        let times = this.state.slots[this.state.currentDate].times;
        let select_next = false;
        for (let i = 0; i < times.length; i++) {
            let opts = {
                value: times[i].begin
            };
            if ((!this.pickup && !times[i].freeDelivery) || (this.pickup && !times[i].freePickup)) {
                opts['disabled'] = 'disabled';
            }
            if ((times[i].begin === this.selectedDateTime && ((!this.pickup && times[i].freeDelivery) || (this.pickup && times[i].freePickup))) || select_next) {
                opts['selected'] = 'selected';
                select_next = false;
            }
            if (times[i].begin === this.selectedDateTime && ((!this.pickup && !times[i].freeDelivery) || (this.pickup && !times[i].freePickup))) {
                select_next = true;
            }
            if (moment(times[i].begin).hour() < 16) {
                result_lunch.push(<option {...opts} key={`time-${i}`}>{this.formatTime(times[i].begin, times[i].end)}</option>);
            }
            else {
                result_supper.push(<option {...opts} key={`time-${i}`}>{this.formatTime(times[i].begin, times[i].end)}</option>);
            }
        }
        let result = [];
        if (result_lunch.length) {
            result.push(
                <optgroup label="Mittagessen" key={`time-lunch`}>
                    {result_lunch}
                </optgroup>
            )
        }
        if (result_supper.length) {
            result.push(
                <optgroup label="Abendessen" key={`time-supper`}>
                    {result_supper}
                </optgroup>
            )
        }
        return result;
    }

    weekday_names = {
        1: 'Montag',
        2: 'Dienstag',
        3: 'Mittwoch',
        4: 'Donnerstag',
        5: 'Freitag',
        6: 'Samstag',
        7: 'Sonntag'
    };

    renderDateDescr(index, weekday) {
        if (weekday === moment().isoWeekday())
            return 'heute';
        if (weekday === moment().isoWeekday() + 1 || (weekday === 1 && moment().isoWeekday() === 7))
            return 'morgen';
        return this.weekday_names[weekday];
    }

    formatDate(date) {
        return moment(date).format('DD.MM.YYYY');
    }

    formatTime(begin, end) {
        return moment(begin).format('kk:mm') + ' - ' + moment(end).format('kk:mm');
    }*/
}
